/*
 * @Author: your name
 * @Date: 2021-07-05 15:33:12
 * @LastEditTime: 2021-07-05 15:33:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\assets\scripts\global.js
 */
Math.toRadians = (deg) => deg * Math.PI / 180;